import { provideUmsatzstatistikModule } from '@softapps/wws/umsatzstatistik';
import {
  provideDarkTheme,
  SOFTLINE_CONFIG_DEFAULT_THEME,
  SOFTLINE_CONFIG_THEMES,
} from '@softline/application';
import { CustomerConfig } from 'apps/softapps/src/customer-config.type';

export const customerConfig: CustomerConfig = {
  version: '0.0.0',
  id: 'at.softline.klauss.softline',
  name: 'Hagebau Klauss Softline',
  providers: [
    { provide: SOFTLINE_CONFIG_DEFAULT_THEME, useValue: 'hagebau' },
    provideDarkTheme(false),
    {
      provide: SOFTLINE_CONFIG_THEMES,
      useValue: {
        key: 'hagebau',
        name: 'Hagebau',
      },
      multi: true,
    },
    provideUmsatzstatistikModule({
      widget: { period: 'today', branch: 'context' },
    }),
  ],
};
